import { assert, assertIsOneOfTypes } from 'common/assertions';
import { type ApiError } from 'types';
import { httpRequest, storytellerHeaders } from 'services/httpRequest.js';
import { StorytellerReduxStoreFactory } from 'store/StorytellerReduxStore';
import {
  personalizedStorySaved,
  personalizedStoryReset,
  personalizedStoryLoaded,
} from 'store/reducers/PersonalizedStoryReducer';
import { createStory } from 'store/TopLevelActions';
import { populateGlobalFilter } from 'store/reducers/DataSourceReducer';
import { EnvironmentFactory } from 'StorytellerEnvironment';
import { selectors } from 'store/selectors/StorySelectors';

function loadPersonalizedStory() {
  StorytellerReduxStoreFactory().dispatch(personalizedStoryLoaded());
}

function savePersonalizedStory() {
  const StorytellerReduxStore = StorytellerReduxStoreFactory();
  assertIsOneOfTypes(EnvironmentFactory().STORY_UID, 'string');
  assert(
    selectors.doesStoryExist(StorytellerReduxStore.getState(), EnvironmentFactory().STORY_UID!),
    'Cannot save personalized version of non-existent story',
  );

  const originalStoryJson = selectors.serializeStory(EnvironmentFactory().STORY_UID!)(
    StorytellerReduxStore.getState(),
  );

  const headers = {
    ...storytellerHeaders(),
    'Content-Type': 'application/json',
  };

  const requestBody = {
    personalized_story_data: originalStoryJson,
  };

  const url = `/stories/api/v1/stories/${EnvironmentFactory().STORY_UID}/personalized`;
  return httpRequest('POST', url, {
    data: requestBody,
    headers: headers,
  }).then(
    () => {
      StorytellerReduxStore.dispatch(personalizedStorySaved());
      return originalStoryJson;
    },
    (error: ApiError) => {
      console.error('Personalized story save failed:', error);
      return Promise.reject(error);
    },
  );
}

function resetPersonalizedStory() {
  assertIsOneOfTypes(EnvironmentFactory().STORY_UID, 'string');
  const url = `/stories/api/v1/stories/${EnvironmentFactory().STORY_UID}/personalized`;
  const Environment = EnvironmentFactory();
  const StorytellerReduxStore = StorytellerReduxStoreFactory();

  const headers = {
    ...storytellerHeaders(),
    'Content-Type': 'application/json',
  };

  return httpRequest('DELETE', url, {
    headers: headers,
  }).then(() => {
    StorytellerReduxStore.dispatch(personalizedStoryReset());
    // Add null check for STORY_DATA
    if (Environment.STORY_DATA) {
      StorytellerReduxStore.dispatch(populateGlobalFilter(Environment.STORY_DATA));
      StorytellerReduxStore.dispatch(createStory(Environment.STORY_DATA));
    }
  });
}

export default { savePersonalizedStory, resetPersonalizedStory, loadPersonalizedStory };
